<template>
  <div
    :id="uuid"
    ref="eventHeaderBlock"
    class="bg-white rounded-xl"
    :class="[formData.blockShadow && 'shadow-lg']"
    :style="{
      'scroll-margin-top': pageEditorStore.scrollMarginTop,
      color: formData.textColor,
      'background-color': formData.bgColor,
      ...useEditorFontFamily(formData.textFontFamily),
    }"
  >
    <EventsItemPageHeader
      :hide-title="formData.hideTitle"
      :hide-image="formData.hideImage"
      :hide-dates="formData.hideDates"
      :hide-google-calendar="formData.hideGoogleCalendar"
      :hide-hub-dates="formData.hideHubDates"
      :hide-place="formData.hidePlace"
      :hide-sharing="formData.hideSharing"
      :hide-bottom-section="formData.hideBottomSection"
      :overlay-text="formData.overlayText"
      :show-overlay="formData.showOverlay"
      :hide-favorite-button="formData.hideFavoriteButton"
      :hide-meeting-system-button="formData.hideMeetingSystemButton"
      :buttons="formData.buttons"
      @loaded="onLoaded"
    />
  </div>
</template>

<script setup lang="ts">
import { usePageEditor } from '~/stores/page-editor'
import type { ButtonInterface } from '~/components/page-editor/common'

interface FormDataInterface {
  buttons?: ButtonInterface[]
  hideImage: boolean
  hideTitle: boolean
  hideDates: boolean
  hideSharing?: boolean
  hideBottomSection?: boolean
  hideGoogleCalendar: boolean
  hideHubDates: boolean
  hidePlace: boolean
  blockShadow?: boolean
  textColor?: string
  bgColor?: string
  showOverlay?: boolean
  overlayText?: string
  hideFavoriteButton?: boolean
  hideMeetingSystemButton?: boolean
  textFontFamily?: string
}

interface PropsInterface {
  uuid: string
  formData: FormDataInterface
}

defineProps<PropsInterface>()

const emit = defineEmits(['loaded'])

const pageEditorStore = usePageEditor()

const eventHeaderBlock = ref<HTMLElement | null>(null)

const onLoaded = () => {
  emit('loaded', eventHeaderBlock, 'event-header')
}
</script>
